module.exports = __webpack_public_path__ + "img/progress-active.1f1cc834.svg";